export interface CreateAccountData {
	email: string;
	password: string;
	passwordRepeat: string;
	referrer: string;
}

export interface Country {
	en: string;
	pl: string;
	iso: string;
}

export const supportedCountries: Country[] = [
	{ en: 'Afghanistan', pl: 'Afganistan', iso: 'AF' },
	{ en: 'Aland Islands', pl: 'Wyspy Alandzkie', iso: 'AX' },
	{ en: 'Albania', pl: 'Albania', iso: 'AL' },
	{ en: 'Algeria', pl: 'Algieria', iso: 'DZ' },
	{ en: 'American Samoa', pl: 'Samoa Amerykańskie', iso: 'AS' },
	{ en: 'Andorra', pl: 'Andora', iso: 'AD' },
	{ en: 'Angola', pl: 'Angola', iso: 'AO' },
	{ en: 'Anguilla', pl: 'Anguilla', iso: 'AI' },
	{ en: 'Antarctica', pl: 'Anguilla', iso: 'AQ' },
	{ en: 'Antigua and Barbuda', pl: 'Antigua i Barbuda', iso: 'AG' },
	{ en: 'Argentina', pl: 'Argentyna', iso: 'AR' },
	{ en: 'Armenia', pl: 'Armenia', iso: 'AM' },
	{ en: 'Aruba', pl: 'Aruba', iso: 'AW' },
	{ en: 'Australia', pl: 'Australia', iso: 'AU' },
	{ en: 'Austria', pl: 'Austria', iso: 'AT' },
	{ en: 'Azerbaijan', pl: 'Azerbejdżan', iso: 'AZ' },
	{ en: 'Bahamas', pl: 'Bahamy', iso: 'BS' },
	{ en: 'Bahrain', pl: 'Bahrajn', iso: 'BH' },
	{ en: 'Bangladesh', pl: 'Bangladesz', iso: 'BD' },
	{ en: 'Barbados', pl: 'Barbados', iso: 'BB' },
	{ en: 'Belarus', pl: 'Białoruś', iso: 'BY' },
	{ en: 'Belgium', pl: 'Belgia', iso: 'BE' },
	{ en: 'Belize', pl: 'Belize', iso: 'BZ' },
	{ en: 'Benin', pl: 'Benin', iso: 'BJ' },
	{ en: 'Bermuda', pl: 'Bermudy', iso: 'BM' },
	{ en: 'Bhutan', pl: 'Bhutan', iso: 'BT' },
	{ en: 'Bolivia', pl: 'Boliwia', iso: 'BO' },
	{ en: 'Bonaire', pl: 'Bonaire', iso: 'BQ' },
	{ en: 'Bosnia and Herzegovina', pl: 'Bośnia i Hercegowina', iso: 'BA' },
	{ en: 'Botswana', pl: 'Botswana', iso: 'BA' },
	{ en: 'Bouvet Island', pl: 'Wyspa Bouveta', iso: 'BV' },
	{ en: 'Brazil', pl: 'Brazylia', iso: 'BR' },
	{ en: 'British Indian Ocean Territory', pl: 'Brytyjskie Terytorium Oceanu Indyjskiego', iso: 'IO' },
	{ en: 'Brunei Darussalam', pl: 'Brunei Darussalam', iso: 'BN' },
	{ en: 'Bulgaria', pl: 'Bułgaria', iso: 'BG' },
	{ en: 'Burkina Faso', pl: 'Burkina Faso', iso: 'BF' },
	{ en: 'Burundi', pl: 'Burkina Faso', iso: 'BI' },
	{ en: 'Cabo Verde', pl: 'Cabo Verde', iso: 'CV' },
	{ en: 'Cambodia', pl: 'Kambodża', iso: 'KH' },
	{ en: 'Cameroon', pl: 'Kamerun', iso: 'CM' },
	{ en: 'Canada', pl: 'Kanada', iso: 'CA' },
	{ en: 'Cayman Islands', pl: 'Kajmany', iso: 'KY' },
	{ en: 'Central African Republic', pl: 'Republika Środkowoafrykańska', iso: 'CF' },
	{ en: 'Chad', pl: 'Czad', iso: 'TD' },
	{ en: 'Chile', pl: 'Chile', iso: 'CL' },
	{ en: 'China', pl: 'Chiny', iso: 'CN' },
	{ en: 'Christmas Island', pl: 'Wyspa Bożego Narodzenia', iso: 'CX' },
	{ en: 'Cocos (Keeling) Islands', pl: 'Wyspy Kokosowe', iso: 'CC' },
	{ en: 'Colombia', pl: 'Kolumbia', iso: 'CO' },
	{ en: 'Comoros', pl: 'Komory', iso: 'KM' },
	{ en: 'Congo', pl: 'Kongo', iso: 'CG' },
	{ en: 'Cook Islands', pl: 'Wyspy Cooka', iso: 'CK' },
	{ en: 'Costa Rica', pl: 'Kostaryka', iso: 'CR' },
	{ en: "Côte d'Ivoire", pl: 'Wybrzeże Kości Słoniowej', iso: 'CI' },
	{ en: 'Croatia', pl: 'Chorwacja', iso: 'HR' },
	{ en: 'Cuba', pl: 'Kuba', iso: 'CU' },
	{ en: 'Curaçao', pl: 'Curaçao', iso: 'CW' },
	{ en: 'Cyprus', pl: 'Cypr', iso: 'CY' },
	{ en: 'Czechia', pl: 'Czechy', iso: 'CZ' },
	{ en: 'Denmark', pl: 'Dania', iso: 'DK' },
	{ en: 'Djibouti', pl: 'Dżibuti', iso: 'DJ' },
	{ en: 'Dominica', pl: 'Dominika', iso: 'DM' },
	{ en: 'Dominican Republic', pl: 'Dominikana', iso: 'DO' },
	{ en: 'Ecuador', pl: 'Ekwador', iso: 'EC' },
	{ en: 'Egypt', pl: 'Egipt', iso: 'EG' },
	{ en: 'El Salvador', pl: 'Salwador', iso: 'SV' },
	{ en: 'Equatorial Guinea', pl: 'Gwinea Równikowa', iso: 'GQ' },
	{ en: 'Eritrea', pl: 'Erytrea', iso: 'ER' },
	{ en: 'Estonia', pl: 'Estonia', iso: 'EE' },
	{ en: 'Eswatini', pl: 'Eswatini', iso: 'SZ' },
	{ en: 'Ethiopia', pl: 'Etiopia', iso: 'ET' },
	{ en: 'Falkland Islands', pl: 'Falklandy', iso: 'FK' },
	{ en: 'Faroe Islands', pl: 'Wyspy Owcze', iso: 'FO' },
	{ en: 'Fiji', pl: 'Fidżi', iso: 'FJ' },
	{ en: 'Finland', pl: 'Finlandia', iso: 'FI' },
	{ en: 'France', pl: 'Francja', iso: 'FR' },
	{ en: 'French Guiana', pl: 'Gujana Francuska', iso: 'GF' },
	{ en: 'French Polynesia', pl: 'Polinezja Francuska', iso: 'PF' },
	{ en: 'French Southern Territories', pl: 'Francuskie Terytoria Południowe', iso: 'TF' },
	{ en: 'Gabon', pl: 'Gabon', iso: 'GA' },
	{ en: 'Gambia', pl: 'Gambia', iso: 'GM' },
	{ en: 'Georgia', pl: 'Gruzja', iso: 'GE' },
	{ en: 'Germany', pl: 'Niemcy', iso: 'DE' },
	{ en: 'Ghana', pl: 'Ghana', iso: 'GH' },
	{ en: 'Gibraltar', pl: 'Gibraltar', iso: 'GI' },
	{ en: 'Greece', pl: 'Grecja', iso: 'GR' },
	{ en: 'Greenland', pl: 'Grenlandia', iso: 'GL' },
	{ en: 'Grenada', pl: 'Grenada', iso: 'GD' },
	{ en: 'Guadeloupe', pl: 'Gwadelupa', iso: 'GP' },
	{ en: 'Guam', pl: 'Guam', iso: 'GU' },
	{ en: 'Guatemala', pl: 'Gwatemala', iso: 'GT' },
	{ en: 'Guernsey', pl: 'Guernsey', iso: 'GG' },
	{ en: 'Guinea', pl: 'Gwinea', iso: 'GN' },
	{ en: 'Guinea-Bissau', pl: 'Gwinea Bissau', iso: 'GW' },
	{ en: 'Guyana', pl: 'Gujana', iso: 'GY' },
	{ en: 'Haiti', pl: 'Haiti', iso: 'HT' },
	{ en: 'Heard Island and McDonald Islands', pl: 'Wyspy Heard i McDonalda', iso: 'HM' },
	{ en: 'Holy See', pl: 'Stolica Apostolska', iso: 'VA' },
	{ en: 'Honduras', pl: 'Honduras', iso: 'HN' },
	{ en: 'Hong Kong', pl: 'Hongkong', iso: 'HK' },
	{ en: 'Hungary', pl: 'Węgry', iso: 'HU' },
	{ en: 'Iceland', pl: 'Islandia', iso: 'IS' },
	{ en: 'India', pl: 'Indie', iso: 'IN' },
	{ en: 'Indonesia', pl: 'Indonezja', iso: 'ID' },
	{ en: 'Iran', pl: 'Iran', iso: 'IR' },
	{ en: 'Iraq', pl: 'Irak', iso: 'IQ' },
	{ en: 'Ireland', pl: 'Irlandia', iso: 'IE' },
	{ en: 'Isle of Man', pl: 'Wyspa Man', iso: 'IM' },
	{ en: 'Israel', pl: 'Izrael', iso: 'IL' },
	{ en: 'Italy', pl: 'Włochy', iso: 'IT' },
	{ en: 'Jamaica', pl: 'Jamajka', iso: 'JM' },
	{ en: 'Japan', pl: 'Japonia', iso: 'JP' },
	{ en: 'Jersey', pl: 'Golf', iso: 'JE' },
	{ en: 'Jordan', pl: 'Jordania', iso: 'JO' },
	{ en: 'Kazakhstan', pl: 'Kazachstan', iso: 'KZ' },
	{ en: 'Kenya', pl: 'Kenia', iso: 'KE' },
	{ en: 'Kenya', pl: 'Kiribati', iso: 'KI' },
	{ en: 'Korea', pl: 'Korea', iso: 'KR' },
	{ en: 'Kuwait', pl: 'Kuwejt', iso: 'KW' },
	{ en: 'Kyrgyzstan', pl: 'Kirgistan', iso: 'KG' },
	{ en: 'Latvia', pl: 'Łotwa', iso: 'LV' },
	{ en: 'Lebanon', pl: 'Liban', iso: 'LB' },
	{ en: 'Lesotho', pl: 'Lesoto', iso: 'LS' },
	{ en: 'Liberia', pl: 'Liberia', iso: 'LR' },
	{ en: 'Libya', pl: 'Libia', iso: 'LY' },
	{ en: 'Liechtenstein', pl: 'Liechtenstein', iso: 'LI' },
	{ en: 'Lithuania', pl: 'Litwa', iso: 'LT' },
	{ en: 'Luxembourg', pl: 'Luksemburg', iso: 'LU' },
	{ en: 'Macao', pl: 'Makau', iso: 'MO' },
	{ en: 'Macedonia', pl: 'Macedonia', iso: 'MK' },
	{ en: 'Madagascar', pl: 'Madagaskar', iso: 'MG' },
	{ en: 'Malawi', pl: 'Malawi', iso: 'MW' },
	{ en: 'Malaysia', pl: 'Malezja', iso: 'MY' },
	{ en: 'Maldives', pl: 'Malediwy', iso: 'MV' },
	{ en: 'Mali', pl: 'Mali', iso: 'ML' },
	{ en: 'Malta', pl: 'Malta', iso: 'MT' },
	{ en: 'Marshall Islands', pl: 'Wyspy Marshalla', iso: 'MH' },
	{ en: 'Martinique', pl: 'Martynika', iso: 'MQ' },
	{ en: 'Mauritania', pl: 'Mauretania', iso: 'MR' },
	{ en: 'Mauritius', pl: 'Mauritius', iso: 'MU' },
	{ en: 'Mayotte', pl: 'Majotta', iso: 'YT' },
	{ en: 'Mexico', pl: 'Meksyk', iso: 'MX' },
	{ en: 'Micronesia', pl: 'Mikronezja', iso: 'FM' },
	{ en: 'Moldova', pl: 'Mołdawia', iso: 'MD' },
	{ en: 'Monaco', pl: 'Monako', iso: 'MC' },
	{ en: 'Mongolia', pl: 'Mongolia', iso: 'MN' },
	{ en: 'Montenegro', pl: 'Czarnogóra', iso: 'ME' },
	{ en: 'Montserrat', pl: 'Montserrat', iso: 'MS' },
	{ en: 'Morocco', pl: 'Maroko', iso: 'MA' },
	{ en: 'Mozambique', pl: 'Mozambik', iso: 'MZ' },
	{ en: 'Myanmar', pl: 'Birma', iso: 'Myanmar' },
	{ en: 'Namibia', pl: 'Namibia', iso: 'NA' },
	{ en: 'Nauru', pl: 'Nauru', iso: 'NR' },
	{ en: 'Nepal', pl: 'Nepal', iso: 'NP' },
	{ en: 'Netherlands', pl: 'Holandia', iso: 'NL' },
	{ en: 'New Caledonia', pl: 'Nowa Kaledonia', iso: 'NC' },
	{ en: 'New Zealand', pl: 'Nowa Zelandia', iso: 'NZ' },
	{ en: 'Nicaragua', pl: 'Nikaragua', iso: 'NI' },
	{ en: 'Niger', pl: 'Niger', iso: 'NE' },
	{ en: 'Nigeria', pl: 'Nigeria', iso: 'NG' },
	{ en: 'Niue', pl: 'Niue', iso: 'NU' },
	{ en: 'Norfolk Island', pl: 'Wyspa Norfolk', iso: 'NF' },
	{ en: 'Northern Mariana Islands', pl: 'Mariany Północne', iso: 'MP' },
	{ en: 'Norway', pl: 'Norwegia', iso: 'NO' },
	{ en: 'Oman', pl: 'Oman', iso: 'OM' },
	{ en: 'Pakistan', pl: 'Pakistan', iso: 'PK' },
	{ en: 'Palau', pl: 'Palau', iso: 'PW' },
	{ en: 'Palestine', pl: 'Palestyna', iso: 'PS' },
	{ en: 'Panama', pl: 'Panama', iso: 'PA' },
	{ en: 'Panama', pl: 'Papua Nowa Gwinea', iso: 'PG' },
	{ en: 'Paraguay', pl: 'Paragwaj', iso: 'PY' },
	{ en: 'Peru', pl: 'Peru', iso: 'PE' },
	{ en: 'Philippines', pl: 'Filipiny', iso: 'PH' },
	{ en: 'Pitcairn', pl: 'Pitcairn', iso: 'PN' },
	{ en: 'Poland', pl: 'Polska', iso: 'PL' },
	{ en: 'Portugal', pl: 'Portugalia', iso: 'PT' },
	{ en: 'Puerto Rico', pl: 'Portoryko', iso: 'PR' },
	{ en: 'Qatar', pl: 'Katar', iso: 'QA' },
	{ en: 'Réunion', pl: 'Zjazd', iso: 'RE' },
	{ en: 'Romania', pl: 'Rumunia', iso: 'RO' },
	{ en: 'Russian Federation', pl: 'Rosja', iso: 'RU' },
	{ en: 'Rwanda', pl: 'Rwanda', iso: 'RW' },
	{ en: 'Saint Barthélemy', pl: 'Saint Barthelemy', iso: 'BL' },
	{
		en: 'Saint Helena, Ascension and Tristan da Cunha',
		pl: 'Święta Helena, Wniebowstąpienie i Tristan da Cunha',
		iso: 'SH',
	},
	{ en: 'Saint Kitts and Nevis', pl: 'Święta Kitts i Nevis', iso: 'KN' },
	{ en: 'Saint Lucia', pl: 'Święta Lucia', iso: 'LC' },
	{ en: 'Saint Martin', pl: 'Święty Martin (część francuska)', iso: 'MF' },
	{ en: 'Saint Pierre and Miquelon', pl: 'x', iso: 'PM' },
	{ en: 'Saint Vincent and the Grenadines', pl: 'x', iso: 'VC' },
	{ en: 'Samoa', pl: 'Samoa', iso: 'WS' },
	{ en: 'San Marino', pl: 'San Marino', iso: 'SM' },
	{ en: 'Sao Tome and Principe', pl: 'Wyspy Świętego Tomasza i Książęca', iso: 'ST' },
	{ en: 'Saudi Arabia', pl: 'Arabia Saudyjska', iso: 'SA' },
	{ en: 'Senegal', pl: 'Senegal', iso: 'SN' },
	{ en: 'Serbia', pl: 'Serbia', iso: 'RS' },
	{ en: 'Seychelles', pl: 'Seszele', iso: 'SC' },
	{ en: 'Sierra Leone', pl: 'Sierra Leone', iso: 'SL' },
	{ en: 'Singapore', pl: 'Singapur', iso: 'SG' },
	{ en: 'Slovakia', pl: 'Słowacja', iso: 'SK' },
	{ en: 'Slovenia', pl: 'Słowenia', iso: 'SI' },
	{ en: 'Solomon Islands', pl: 'Wyspy Salomona', iso: 'SB' },
	{ en: 'Somalia', pl: 'Somali', iso: 'SO' },
	{ en: 'South Africa', pl: 'Afryka Południowa', iso: 'ZA' },
	{ en: 'South Sudan', pl: 'Południowy Sudan', iso: 'SS' },
	{ en: 'Spain', pl: 'Hiszpania', iso: 'ES' },
	{ en: 'Sri Lanka', pl: 'Sri Lanka', iso: 'LK' },
	{ en: 'Sudan', pl: 'Sudan', iso: 'SD' },
	{ en: 'Suriname', pl: 'Surinam', iso: 'SR' },
	{ en: 'Svalbard', pl: 'Svalbard', iso: 'SJ' },
	{ en: 'Sweden', pl: 'Szwecja', iso: 'SE' },
	{ en: 'Switzerland', pl: 'Szwajcaria', iso: 'CH' },
	{ en: 'Syrian Arab Republic', pl: 'Syryjska Republika Arabska', iso: 'SY' },
	{ en: 'Taiwan', pl: 'Tajwan', iso: 'TW' },
	{ en: 'Tajikistan', pl: 'Tadżykistan', iso: 'TJ' },
	{ en: 'Tanzania, United Republic of', pl: 'Tanzania, Zjednoczona Republika', iso: 'TZ' },
	{ en: 'Thailand', pl: 'Tajlandia', iso: 'TH' },
	{ en: 'Timor-Leste', pl: 'Timor Wschodni', iso: 'TL' },
	{ en: 'Togo', pl: 'Togo', iso: 'TG' },
	{ en: 'Tokelau', pl: 'Tokelau', iso: 'TK' },
	{ en: 'Tonga', pl: 'Tonga', iso: 'TO' },
	{ en: 'Trinidad and Tobago', pl: 'Trynidad i Tobago', iso: 'TT' },
	{ en: 'Tunisia', pl: 'Tunezja', iso: 'TN' },
	{ en: 'Turkey', pl: 'Turcja', iso: 'TR' },
	{ en: 'Turkmenistan', pl: 'Turkmenia', iso: 'TM' },
	{ en: 'Turks and Caicos Islands', pl: 'Wyspy Turks i Caicos', iso: 'TC' },
	{ en: 'Tuvalu', pl: 'Tuvalu', iso: 'TV' },
	{ en: 'Uganda', pl: 'Uganda', iso: 'UG' },
	{ en: 'Ukraine', pl: 'Ukraina', iso: 'UA' },
	{ en: 'United Arab Emirates', pl: 'Zjednoczone Emiraty Arabskie', iso: 'AE' },
	{ en: 'United Kingdom', pl: 'Wielka Brytania', iso: 'GB' },
	{ en: 'United States of America', pl: 'Stany Zjednoczone Ameryki', iso: 'US' },
	{ en: 'Uruguay', pl: 'Urugwaj', iso: 'UY' },
	{ en: 'Uzbekistan', pl: 'Uzbekistan', iso: 'UZ' },
	{ en: 'Vanuatu', pl: 'Vanuatu', iso: 'VU' },
	{ en: 'Venezuela', pl: 'Wenezuela', iso: 'VE' },
	{ en: 'Viet Nam', pl: 'Wietnam', iso: 'VN' },
	{ en: 'Yemen', pl: 'Jemen', iso: 'YE' },
	{ en: 'Zambia', pl: 'Zambia', iso: 'ZM' },
	{ en: 'Zambia', pl: 'Zimbabwe', iso: 'ZW' },
];
